import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Company List", -1)
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-striped" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "CompanyUId"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Phone"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Producer tokens")
  ])
], -1)
const _hoisted_6 = { scope: "row" }
const _hoisted_7 = { class: "list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("table", _hoisted_4, [
        _hoisted_5,
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backendResponse.items, (company) => {
            return (_openBlock(), _createBlock("tr", {
              key: company.id
            }, [
              _createVNode("th", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: '/receiver/company/'+company.CompanyUId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(company.Name) + " (" + _toDisplayString(company.DisplayName) + ")", 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode("td", null, _toDisplayString(company.CompanyUId), 1),
              _createVNode("td", null, _toDisplayString(company.Email), 1),
              _createVNode("td", null, _toDisplayString(company.Phone), 1),
              _createVNode("td", null, _toDisplayString(company.Status), 1),
              _createVNode("td", null, [
                _createVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(company.Producers, (producer, index) => {
                    return (_openBlock(), _createBlock("li", {
                      key: index,
                      class: ['list-group-item', producer.Enabled ? 'list-group-item-success' : 'list-group-item-warning']
                    }, _toDisplayString(producer.Name), 3))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}